<template> 
  <div class="link"> 
        <vx-tooltip color="primary" text="Edit Alarm" position="left">
    <vs-button color="primary" type="flat"   icon-pack="feather" icon="icon-settings" @click="open()" ></vs-button>
  </vx-tooltip>

  </div> 
</template> 


<script>


export default {
  data () {
    return {
      data:{}
    }
  },
  methods:{
    open () {

      this.$parent.$parent.$parent.$parent.$parent.editAlarm(this.data)
    }

  }
}
</script>